import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsExport from 'highcharts/modules/export-data';
import HighchartsExporting from 'highcharts/modules/exporting';
import React, { useRef } from 'react';
import { Button, Content, Dropdown, Icon, Input, InputGroup, Popover, Table, Whisper } from 'rsuite';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { LoadingSpinerLocal } from '../../../../../../components/LoadingSpinner';
import { HighchartsOptions } from '../../../../../../utils/HighchartsConfig';
import { formatterXLabel, formatterYLabel, seriesColors } from '../../utils';
import styles from './CoberturaProdutosRedeChart.module.scss';
const { Pagination } = Table;

HighchartsExporting(Highcharts);
HighchartsExport(Highcharts);
Highcharts.setOptions(HighchartsOptions);

export const CoberturaProdutosRedeChart = ({ rede, data, loading, onChangePage, onSearch }) => {
  const topPricesChartRef = useRef(null);

  const mapCategories = data => {
    return data?.content?.map(item => item.rede);
  };

  const mapDataSeries = data => {
    const dataSeries = {
      data: data?.content?.map((item, index) => ({
        name: item.rede,
        y: item.cobertura,
        color: seriesColors[index],
      })),
    };

    return dataSeries;
  };

  const topPricesChart = {
    chart: {
      type: 'bar',
      height: 500,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    tooltip: {
      enabled: false,
      formatter: (props: any) => {
        return `
                    ${props.chart?.hoverPoint?.name}: <b>${props.chart?.hoverPoint?.y}%</b>
                `;
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: '{y:.2f}%', // valor em porcentagem de cada barra
        },
      },
    },
    yAxis: {
      breakSize: 1,
      alignTicks: false,
      title: {
        text: '',
      },
      labels: {
        // Nome das porcentagens na linha horizontal
        formatter: (props: any) => formatterYLabel(props),
      },
    },
    xAxis: {
      categories: data?.content?.length ? mapCategories(data) : [],
      labels: {
        // Nome das redes na linha vertical
        formatter: (props: any) => formatterXLabel(props),
      },
    },
    series: data?.content?.length ? mapDataSeries(data) : [],
  };

  const MenuPopover = ({ onSelect, ...rest }) => (
    <Popover {...rest} full>
      <Dropdown.Menu onSelect={onSelect} style={{ width: '196px' }}>
        <Dropdown.Item eventKey={2}>Download</Dropdown.Item>
      </Dropdown.Menu>
    </Popover>
  );

  return (
    <Content className={styles.container}>
      <LoadingSpinerLocal loading={loading} size="md" />
      <div className={styles.header}>
        <div>
          <h6 className={styles.title}>COBERTURA DE PRODUTOS POR REDE</h6>
          <p className={styles.subtitle}>Confira a cobertura do Infopanel para os seus produtos rede a rede</p>
        </div>
        <div className={styles['header-actions']}>
          <InputGroup inside className={styles['search-container']}>
            <InputGroup.Addon>
              <Icon icon="search" className={styles['search-icon']} />
            </InputGroup.Addon>
            <Input className={styles['search-input']} placeholder="Pesquisar por uma rede" onChange={onSearch} />
          </InputGroup>
          {/* <Whisper
                        placement="bottomEnd"
                        trigger="click"
                        speaker={(
                            <MenuPopover
                                // onSelect={(key) => onSelectThreeDotButtonOption()}
                            />
                        )}
                    >
                        <Button className={styles['btn-popover']}>
                            <MoreVertIcon className={styles['icon-more-vert']} />
                        </Button>
                    </Whisper> */}
        </div>
      </div>

      <HighchartsReact ref={topPricesChartRef} highcharts={Highcharts} options={topPricesChart} />
      <Pagination activePage={data.page?.number + 1} total={data.page?.totalElements} displayLength={10} showLengthMenu={false} onChangePage={onChangePage} />
    </Content>
  );
};
